export default __webpack_public_path__ + "locales/lv/DeleteDialog.json?hash=20cebbe160898a2d62942ae960d3250b";